import { axios } from '../util'

const GET_SECRET_WORD = '/secret-word'

export const getSecretWord = () => axios.get(GET_SECRET_WORD)
